<template>
  <v-card class="mx-auto">
    <v-img
      :lazy-src="'images/project/low_res/' + image"
      :src="'images/project/' + image"
      @load="$redrawVueMasonry()"
    />

    <v-card-title> {{ title }} </v-card-title>
    <v-card-subtitle>
      <b>Keywords:</b> {{ this.keywords.join(", ") }} <br />
      <b>Date:</b> {{ date }}
    </v-card-subtitle>

    <v-card-text>
      {{ text }}
    </v-card-text>

    <v-card-actions>
      <v-btn color="primary" block text :href="link" target="_blank">
        Open in GitHub
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    date: {
      type: String,
    },
    keywords: {
      type: Array,
    },
    image: {
      type: String,
    },
    link: {
      type: String,
    },
  },
};
</script>
